import React, { Component } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import inRange from 'lodash/inRange';
import Headroom from 'react-headroom';

import { scrollWindowTo, computeDistanceFromTop, isBrowser } from '../../lib/utils';

const mainContentIds = () => {
  let childIds = [];
  let container = isBrowser() && document.getElementById('mainContentContainer');
  if (container) {
    for (let c = 0; c < container.childNodes.length; c++) {
      if (container.childNodes[c].nodeType === 1) {
        childIds.push(container.childNodes[c].id);
      }
    }
  }
  return childIds;
};

const getStickyElementsObj = () => {
  let stickyElementsObj = {};
  mainContentIds().map(id => (stickyElementsObj[id] = computeDistanceFromTop(id) - 100));
  return stickyElementsObj;
};

export default class SideNav extends Component {
  state = { selectedCard: '' };

  componentDidMount() {
    // const elm = document.querySelector(`#overview`).offsetTop;
    // scrollWindowTo(elm, 1000);
    document.addEventListener('scroll', this.highlightActiveNavElement);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.highlightActiveNavElement);
  }

  navItems = {
    overview: {
      icon: <i className="icon icon-hg-snowflake  " />,
      text: 'Overview',
    },
    lodges: { icon: <i className="icon icon-hg-home" />, text: 'Lodges' },
    flights: { icon: <i className="icon icon-hg-flight" />, text: 'Flights' },
    attractions: {
      icon: <i className="icon icon-hg-attraction" />,
      text: 'Attractions',
    },
    sightings: {
      icon: <i className="icon icon-hg-binoculars" />,
      text: 'Sightings',
    },
    mountainFinder: {
      icon: <i className="icon icon-hg-mountains-summit" />,
      text: 'Mountain Finder',
    },
    festivals: {
      icon: <i className="icon icon-hg-list-star" />,
      text: 'Festivals',
    },
    sidetrips: {
      icon: <i className="icon icon-hg-route" />,
      text: 'Side Trips',
    },
  };

  render() {
    const { selectedCard } = this.state;

    return (
      <div className="sidebar">
        <Headroom disableInlineStyles>
          <div className="rat">
            <Nav tabs vertical className="v-tabs places-tabs">
              {mainContentIds().map(id => {
                return (
                  <NavItem key={id} style={{}}>
                    <NavLink
                      href={`#${id}`}
                      active={selectedCard === id ? true : false}
                      onClick={() => this.scrollIntoView(id)}
                    >
                      {this.navItems[id].icon} {this.navItems[id].text}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>
          </div>
        </Headroom>
      </div>
    );
  }

  highlightActiveNavElement = () => {
    const windowY = window.scrollY;
    let stickyElementsObj = getStickyElementsObj();
    let stickyElementsArr = Object.values(stickyElementsObj);
    let stickyElementsHeadingArr = Object.keys(stickyElementsObj);

    let activeElement = stickyElementsArr.reduce((acc, elem, index, array) => {
      if (index + 1 !== array.length && inRange(windowY, elem, array[index + 1]))
        return elem;
      else if (windowY >= elem) return elem;
      return acc;
    }, 0);

    this.setState({
      selectedCard: stickyElementsHeadingArr[stickyElementsArr.indexOf(activeElement)],
    });
  };

  scrollIntoView(elmId) {
    this.setState({
      selectedCard: elmId,
    });

    const elmY = document.querySelector(`#${elmId}`).offsetTop;
    // document.querySelector(`#${elmId}`).scrollIntoView({
    //   behavior: "smooth"
    // });
    scrollWindowTo(elmY, 300);
  }
}



// WEBPACK FOOTER //
// ./src/screens/Places/SideNav.jsx